// The site's run map for a day or a week (linked runs phase 7, spec §7;
// Thomas T9: the whole-day map after the per-run one). Bulk sorts on the
// left with what was tipped onto them; packing lines on the right; a link
// for each bulk sort → line pair, with the crates and kg of the bulk-sort
// pallets tipped across it. Built from tips (tipping_log.from_bulk_sort, mig
// 20261290000000), no link table. Pure.

import { isoWeekStart } from './runFlowGroups'
import { addRun, num as n, type RunNode } from './runFlowLinks'

export interface MapEdgeRow {
  run_id: string
  bin_quantity: number
  net_weight_kg: number | string | null
  runs: { run_number: string | null } | null
  bins: { source_run_id: string | null; src: { run_number: string | null } | null } | null
}
export interface MapIntakeRow {
  run_id: string
  bin_quantity: number
  net_weight_kg: number | string | null
  runs: { run_number: string | null } | null
}

export type MapNode = RunNode
export interface MapEdge { from: string; to: string; count: number; kg: number }
export interface RunMap { bulk: MapNode[]; lines: MapNode[]; edges: MapEdge[] }

export function buildRunMap(edgeRows: MapEdgeRow[], intakeRows: MapIntakeRow[]): RunMap {
  const bulk = new Map<string, MapNode>()
  const lines = new Map<string, MapNode>()
  const edges = new Map<string, MapEdge>()
  for (const r of intakeRows) addRun(bulk, r.run_id, r.runs?.run_number ?? null, 'BULK_SORT', n(r.bin_quantity), n(r.net_weight_kg))
  for (const r of edgeRows) {
    const from = r.bins?.source_run_id
    if (!from) continue
    if (!bulk.has(from)) addRun(bulk, from, r.bins?.src?.run_number ?? null, 'BULK_SORT', 0, 0)
    addRun(lines, r.run_id, r.runs?.run_number ?? null, null, n(r.bin_quantity), n(r.net_weight_kg))
    const key = `${from}>${r.run_id}`
    const e = edges.get(key) ?? { from, to: r.run_id, count: 0, kg: 0 }
    e.count += n(r.bin_quantity); e.kg += n(r.net_weight_kg)
    edges.set(key, e)
  }
  const byNumber = (a: MapNode, b: MapNode) => a.runNumber.localeCompare(b.runNumber)
  return { bulk: [...bulk.values()].sort(byNumber), lines: [...lines.values()].sort(byNumber), edges: [...edges.values()] }
}

/** The instants a packhouse day or its ISO week covers: 06:00 SAST to 06:00. */
export function mapWindow(day: string, span: 'day' | 'week'): { from: string; to: string } {
  const start = span === 'week' ? isoWeekStart(day) : day
  const d = new Date(`${start}T06:00:00+02:00`)
  const end = new Date(d)
  end.setUTCDate(end.getUTCDate() + (span === 'week' ? 7 : 1))
  return { from: d.toISOString(), to: end.toISOString() }
}
